"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var withStyles_1 = require("../decorators/withStyles");

var Radio_styles_1 = require("./Radio.styles");

var baseProps_1 = require("../assets/baseProps");

var Text_1 = require("../Text/Text");

var classNames = require("classnames");

var Radio =
/** @class */
function (_super) {
  __extends(Radio, _super);

  function Radio() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      focus: false
    };

    _this.onFocus = function () {
      _this.setState({
        focus: true
      });
    };

    _this.onBlur = function () {
      _this.setState({
        focus: false
      });
    };

    return _this;
  }

  Radio.prototype.render = function () {
    var _a, _b;

    var _c = this.props,
        label = _c.label,
        disabled = _c.disabled,
        defaultChecked = _c.defaultChecked,
        checked = _c.checked,
        onChange = _c.onChange,
        name = _c.name,
        value = _c.value,
        classes = _c.classes,
        dangerouslyApplyFocusStyle = _c.dangerouslyApplyFocusStyle;
    var focus = this.state.focus;
    var labelClassName = classNames(classes.label, (_a = {}, _a[classes.disabled] = disabled, _a));
    return React.createElement("label", __assign({}, baseProps_1.default(this.props), {
      className: labelClassName
    }), React.createElement("div", {
      className: classNames(classes.radio, (_b = {}, _b[classes.focus] = dangerouslyApplyFocusStyle || focus, _b))
    }, React.createElement("input", {
      className: classes.input,
      type: "radio",
      name: name,
      value: value,
      defaultChecked: defaultChecked,
      checked: checked,
      onChange: onChange && function (e) {
        return onChange(e.target.checked);
      },
      disabled: disabled,
      onFocus: this.onFocus,
      onBlur: this.onBlur
    }), React.createElement("div", {
      className: classes.background
    }), React.createElement("div", {
      className: classes.border
    })), React.createElement("div", {
      className: classes.text
    }, React.createElement(Text_1.default, {
      mode: "control"
    }, label)));
  };

  Radio = __decorate([withStyles_1.withStyles(Radio_styles_1.styles)], Radio);
  return Radio;
}(React.PureComponent);

exports.default = Radio;